import { render, staticRenderFns } from "./EliminarAnotacion.vue?vue&type=template&id=7e0345da&"
import script from "./EliminarAnotacion.vue?vue&type=script&lang=js&"
export * from "./EliminarAnotacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports